import {useVscContext} from "../../content/VscReactContext";
import {useEffect, useState} from "react";
import {IModelConfig} from "./SiteSpecific";

export function getItemsForTab(tabName:string, modelConfig: IModelConfig | null) {
    if (modelConfig === null) return [];
    return modelConfig.views.find(v => v.name === tabName)?.items ?? [];
}
export function useModelConfig(modelId: string) {
    const vscContext = useVscContext();
    const modelConfigUrl = vscContext.getHtmlContentUri("_config/models/" + modelId + ".json");

    const [modelConfig, setModelConfig] = useState<IModelConfig | null>(null);
    useEffect(() => {
        let useResponse = true;
        const f = async () => {

            const modelResponse = await fetch(modelConfigUrl);
            const modelJson = await modelResponse.json() as IModelConfig;
            if (useResponse) {
                setModelConfig(modelJson);
            }
        }
        f();
        return () => {
            useResponse = false;
        }
    }, [modelConfigUrl]);
    return modelConfig;
}